import { ModelBase } from "@shoothill/core";
import { makeObservable, observable } from "mobx";
import { Validator } from "Application/Validation";

export class DocumentListModel extends ModelBase<DocumentListModel> {
    public documentId: string = "";
    public documentTypeLongDescription: string = "";
    public fileName: string = "";
    public documentUrl: string = "";
    public documentModels = observable<DocumentListModel>([]);
    public plotNumber: string = "033";
    public developmentName: string = "Harriers Rest";
    public address1: string | null = "221B Harriers Rest";
    public address2: string | null = "off Eagle Lane";
    public address3: string | null = "Wittering";
    public address4: string | null = "Lincs";
    public postcode: string | null = "TE5 EST";
    constructor() {
        super();
        makeObservable(this, {
            documentId: observable,
            documentTypeLongDescription: observable,
            fileName: observable,
            documentUrl: observable,
            address1: observable,
            address2: observable,
            address3: observable,
            address4: observable,
            postcode: observable,
        });
    }
}

export class DocumentsModelValidator extends Validator<DocumentListModel> {
    constructor() {
        super();
        //this.ruleFor("id").notEmpty();
    }
}
